import { render } from "./SoundAnimation.vue?vue&type=template&id=68e6baf5&scoped=true"
import script from "./SoundAnimation.vue?vue&type=script&lang=js"
export * from "./SoundAnimation.vue?vue&type=script&lang=js"

import "./SoundAnimation.vue?vue&type=style&index=0&id=68e6baf5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e6baf5"]])

export default __exports__